import { Flex, Box, useColorModeValue } from "@chakra-ui/react";
import WithNavigationBarLayout from "src/components/WithNavigationBarLayout";
import DescriptionIcon from "./DescriptionIcon";
import MonitoringsList from "./MonitoringsList";
import MonitoringDetail from "./MonitoringDetail";

export default function MonitoringsView({
  onClose,
  hasMoreMonitorings,
  selectedMonitoring,
  openDescription,
  monitorings,
  onMonitoringDelete,
  openEventView,
  loadMoreMonitorings,
  handleMonitoringSelection,
  toggleFreemiumFlow,
  fetchEventThumbnail,
  toggleShare
}) {
  const borderColor = useColorModeValue("black8", "rgba(255, 255, 255, 0.04)");
  return (
    <>
      <Box width="100%" height="100%">
        <WithNavigationBarLayout
          navigationBarProps={{
            headingKey: "activityLog.heading",
            onClose,
            customIcon: <DescriptionIcon onClick={openDescription} />
          }}
        >
          <Flex height="100%">
            <Box
              flex="0 0 251px"
              height="100%"
              borderRight="1px solid"
              borderColor={borderColor}
            >
              <MonitoringsList
                onDelete={onMonitoringDelete}
                monitorings={Object.values(monitorings)}
                selectedMonitoringId={selectedMonitoring.uniqueId}
                hasMoreMonitorings={hasMoreMonitorings}
                loadMore={loadMoreMonitorings}
                onSelect={handleMonitoringSelection}
              />
            </Box>
            <Box pt="16px" width="100%" height="100%">
              <MonitoringDetail
                toggleFreemiumFlow={toggleFreemiumFlow}
                monitoring={selectedMonitoring}
                openEventView={openEventView}
                fetchEventThumbnail={fetchEventThumbnail}
                toggleShare={toggleShare}
              />
            </Box>
          </Flex>
        </WithNavigationBarLayout>
      </Box>
    </>
  );
}
